import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetJobPostedSuccessLink(jobId: string) {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/jobs/${jobId}/post-job-success`;
}
